// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--i5HOV";
export var banner__content = "banner-module--banner__content--38V4p";
export var banner__content__summary = "banner-module--banner__content__summary--1sHZ2";
export var banner__artwork = "banner-module--banner__artwork--3s9Bg";